
// 获取activity详情
function loadActivityDetail(storeHost, storeKey, handle, callback) {
  fetch(`${storeHost}/shopify-api/activity/detail?key=${storeKey}&handle=${encodeURIComponent(handle)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      const data = parseResult(res);
      const err = data ? null : { message: res.message || 'fail' };
      callback && callback(err, data);
    })
    .catch((error) => {
      callback && callback(error, null);
    });
}

// 获取作者详情信息
function loadAuthorDetail(storeHost, storeKey, handle, callback) {
  fetch(`${storeHost}/shopify-api/contributor/detail?key=${storeKey}&handle=${encodeURIComponent(handle)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      const data = parseResult(res);
      const err = data ? null : { message: res.message || 'fail' };
      callback && callback(err, data);
    })
    .catch((error) => {
      callback && callback(error, null);
    });
}

function parseResult(res = {}) {
  if (res && res.code == 200) {
    return res.data || {};
  }
  return null;
}